<template>
	<div>
		<div class="contactNav" ref='contactNav'>
			<div class="contactNavBox">
				<div class="contactNavFor" :class="navSel==index?'contactNavForXz':''" v-for="(item,index) in navList"
					:key="index" @click="goNavClick(index)">
					{{item.name}}
				</div>
				<div class="contactNavForXian" :style="{
				left:(navSel*(100 / navList.length))+'%'
			}"></div>
			</div>
		</div>
		<template v-if="locale=='zh'">
			<contactCenSqzx v-if="navSel==0&&contactList.length>0" :itema='contactList[0]'></contactCenSqzx>
			<contactCenShfw v-if="navSel==1&&contactList.length>0" :itema='contactList[1]'></contactCenShfw>
			<contactCenHzzx v-if="navSel==2&&contactList.length>0" :itema='contactList[2]'></contactCenHzzx>
		</template>
		<template v-else>
			<contactCenSqzxOne v-if="navSel==0&&contactList.length>0" :itema='contactList[0]'></contactCenSqzxOne>
			<contactCenShfwOne v-if="navSel==1&&contactList.length>0" :itema='contactList[1]'></contactCenShfwOne>
			<contactCenHzzxOne v-if="navSel==2&&contactList.length>0" :itema='contactList[2]'></contactCenHzzxOne>
		</template>
		<Footer></Footer>
	</div>
</template>

<script>
	import {
		get_contact_us_service
	} from '@/api/contact.js'
	import contactCenSqzx from "./contactCenSqzx.vue"
	import contactCenShfw from "./contactCenShfw.vue"
	import contactCenHzzx from "./contactCenHzzx.vue"
	import contactCenSqzxOne from "./contactCenSqzxOne.vue"
	import contactCenShfwOne from "./contactCenShfwOne.vue"
	import contactCenHzzxOne from "./contactCenHzzxOne.vue"
	import Footer from "@/components/footer.vue"
	export default {
		components: {
			contactCenSqzx,
			contactCenShfw,
			contactCenHzzx,
			contactCenSqzxOne,
			contactCenShfwOne,
			contactCenHzzxOne,
			Footer,
		},
		data() {
			return {
				navList: [{
						name: this.$t('i18n_43'),
						value: 'sqzx'
					},
					{
						name: this.$t('i18n_44'),
						value: 'shfw'
					},
					{
						name: this.$t('i18n_45'),
						value: 'hzzx'
					},
				],
				navSel: 0,
				querValue: '',
				contactList: [],
				locale: 'zh'
			}
		},
		mounted() {
			this.locale = this.$i18n.locale;
			this.querValue = this.$route.query.value;
			this.getFw();
		},
		watch: {
			querValue() {
				let t = this;
				console.log(t.querValue)
				if (t.querValue == 'mtzx') {
					t.navSel = 0
					return;
				}
				t.navList.forEach((v, a) => {
					if (t.querValue == v.value) {
						t.navSel = a
					}
				})
				this.$nextTick(function() {
					t.goScoll();
				})
			},
			contactList() {
				let t = this;
				console.log(t.querValue)
				if (t.querValue == 'mtzx') {
					t.navSel = 0
					return;
				}
				t.navList.forEach((v, a) => {
					if (t.querValue == v.value) {
						t.navSel = a
					}
				})
				this.$nextTick(function() {
					t.goScoll();
				})
			}
		},
		methods: {
			goScoll() {
				let t = this;
				let offsetTop = this.$refs['contactNav'].offsetTop;
				// document.documentElement.scrollTop = offsetTop+10;
				var element;
				if(this.nowVibe=='pc'){
					element= document.documentElement
				}else{
					element = document.documentElement.scrollTop ? document.documentElement : document.body;
				}
				if (t.querValue) {
					// document.documentElement.scrollTop = offsetTop + 10;
					element.scrollTop =offsetTop + 10;
				} else {
					element.scrollTop =0;
					// document.documentElement.scrollTop = 0;
				}
			},
			goNavClick(e) {
				this.navSel = e;
			},
			getFw() {
				let data = {}
				get_contact_us_service(data).then(res => {
					console.log(res)
					this.contactList = res.data.list
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.contactNav {
		height: 187px;
		border-bottom: 2px solid #DDDDDD;
		margin-bottom: 88px;

		.contactNavBox {
			width: 1200px;
			height: 187px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			justify-content: space-between;
			position: relative;

			.contactNavForXian {
				width: 400px;
				height: 8px;
				background: #DDDDDD;
				position: absolute;
				bottom: -4px;
				left: 0;
				transition: all 0.3s ease-in-out;
			}

			// .contactNavFor:nth-last-child(1){
			// 	border-right:2px solid #E4E4E4;
			// 	background-color: #f00;
			// }
			// .contactNavFor:last-of-type{
			// 	border-right:2px solid #E4E4E4;
			// 	background-color: #f00;
			// }
			// .contactNavFor:not(:last-child){
			// 	border-right:2px solid #E4E4E4;
			// }
			.contactNavFor:not(:first-child) {
				border-left: 2px solid #E4E4E4;
			}

			.contactNavFor {
				width: 400px;
				height: 60px;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 36px;
				font-family: Source Han Sans CN;
				cursor: pointer;
				font-weight: 400;
				color: #E5E5E5;
				position: relative;
				transition: all 0.3s ease-in-out;
			}

			.contactNavForXz {
				font-weight: bold;
				color: #000000;
				// &::before{
				// 	content: "";
				// 	position: absolute;
				// 	bottom: -68px;
				// 	left: 0;
				// 	width: 400px;
				// 	height: 8px;
				// 	background: #DDDDDD;
				// }
			}
		}
	}

	@media screen and (max-width:1200px) {
		.contactNav{
			margin-bottom: 10px !important;
			height: auto !important;
		}
		.contactNavBox{
			width: 100% !important;
			padding-bottom: 10px !important;
			height: auto !important;
			box-sizing: border-box;
			
			.contactNavFor{
				font-size: 15px !important;
				text-align: center !important;
			}
			.contactNavForXian{
				width: calc(100%/3) !important;
				height: 3px !important;
				bottom: -3px !important;
			}
		}
	}
</style>